function carryCountryParam() {
  const urlParams = new URLSearchParams(window.location.search);
  if(!urlParams) return;
  let country = urlParams.get('country');
  country = country ?? 'de';
  document.querySelectorAll('a[href]').forEach(link => {
    try {
      const url = new URL(link.href, window.location.origin);
      if (url.origin === window.location.origin && !url.searchParams.has('country')) {
        url.searchParams.set('country', country);
        link.href = url.toString();
      }
    } catch (e) {
      // ignore invalid URLs (like anchors or mailto:)
    }
  });
}

document.addEventListener("DOMContentLoaded", function() {
  carryCountryParam();
});